// extracted by mini-css-extract-plugin
export default {"user":"edituser_user__+2S+G"};